import { useEffect, useState } from 'react';
import api from '../services/api';
import { fetchHubConfigCached } from './usePlaylistHub';
import { computeCuratedCountsFromHub } from '../utils/curatedPlaylistCounts';

async function fetchUserPlaylistCount() {
  try {
    const data = await api.get('/api/user/playlists');
    const list = data?.playlists;
    return Array.isArray(list) ? list.length : null;
  } catch {
    return null;
  }
}

export default function useSidebarCuratedCounts() {
  const [counts, setCounts] = useState(null);
  const [userPlaylistsCount, setUserPlaylistsCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchHubConfigCached()
      .then((hub) => {
        if (!cancelled) setCounts(computeCuratedCountsFromHub(hub));
      })
      .catch(() => {
        if (!cancelled) setCounts(null);
      });
    fetchUserPlaylistCount()
      .then((count) => {
        if (!cancelled) setUserPlaylistsCount(count);
      });
    return () => { cancelled = true; };
  }, []);

  return {
    counts,
    userPlaylistsCount,
    userPlaylistsLoaded: userPlaylistsCount !== null,
  };
}
